import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";
import bgAbout from "assets/img/bg-about.jpg";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

// Styles globaux pour les liens
document.body.classList.add('bg-gray-50');

export default function About() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Hero Section with Background Image */}
      <section 
        className="relative overflow-hidden flex items-center"
        style={{ minHeight: "80vh", paddingTop: "6rem", paddingBottom: "6rem" }}
      >
        <img
          src={bgAbout}
          alt="A propos - AidFoundation"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(15, 23, 42, 0.75), rgba(15, 23, 42, 0.85))",
          }}
        />
        <div className="container mx-auto px-4 relative z-10">
          <motion.div 
            className="text-center max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Financement <span className="text-red-600">Non Remboursable</span>
            </h1>
            <p className="text-xl text-white font-medium mb-8 max-w-2xl mx-auto">
              Une solution simple et rapide pour concrétiser vos projets sans vous soucier du remboursement
            </p>
            <motion.div
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="inline-block"
            >
              <Link
                to="/demande"
                className="bg-red-600 hover:bg-red-700 text-white font-semibold text-lg px-8 py-3 rounded-lg shadow-lg transition-all duration-300 inline-block no-underline hover:no-underline"
              >
                Demander un financement
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>
      
      {/* Main Content */}
      <main className="flex-1 py-12 md:py-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden"
          >
            <div className="p-8 md:p-12">
              <div className="text-center mb-12">
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  À propos de <span className="text-red-600">AidFoundation</span>
                </h1>
                <div className="w-24 h-1 bg-red-600 mx-auto my-6"></div>
              </div>

              <div className="space-y-6 text-gray-700">
                <p className="text-lg leading-relaxed">
                  AidFoundation est votre partenaire de confiance pour un accompagnement financier
                  solidaire et accessible. Spécialisée dans les prêts non remboursables, notre mission
                  est de soutenir celles et ceux qui traversent des périodes difficiles ou qui ont
                  besoin d'un coup de pouce pour concrétiser un projet essentiel.
                </p>

                <p className="text-lg leading-relaxed">
                  Que vous soyez étudiant, entrepreneur, parent, travailleur ou retraité, AidFoundation
                  vous accompagne dans vos démarches avec écoute et bienveillance. Notre équipe
                  s'engage à vous fournir les conseils, outils et ressources nécessaires pour avancer
                  sereinement, tout en bâtissant un avenir plus stable.
                </p>

                <div className="bg-blue-50 p-6 rounded-lg my-8 border-l-4 border-blue-500">
                  <p className="text-blue-800 font-medium italic">
                    « Chez AidFoundation, nous croyons qu'un soutien financier ne devrait pas être un fardeau. 
                    C'est pourquoi nos aides sont conçues pour vous libérer de toute obligation de remboursement. »
                  </p>
                </div>

                <p className="text-lg leading-relaxed">
                  Nos services de financement sont exclusivement constitués de prêts non remboursables,
                  offerts dans un esprit de solidarité. Rejoignez dès aujourd'hui la communauté
                  AidFoundation et bénéficiez d'un accompagnement humain, sans dettes et sans contraintes.
                </p>
              </div>

              <div className="mt-12 text-center">
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="inline-block"
                >
                  <Link
                    to="/demande"
                    className="bg-red-600 hover:bg-red-700 text-white font-semibold text-lg px-8 py-3 rounded-lg shadow-lg transition-all duration-300 inline-block no-underline hover:no-underline"
                  >
                    En bénéficier maintenant
                  </Link>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
